module.exports = __webpack_public_path__ + "img/11088027_L.0274bf20.png";